import { createContext, useContext } from 'react';
import { IEntitySelectionContext, IPanelStateContext } from './types';
import { assertNotNil } from '../../../utils/types';

export const EntitySelectionContext =
  createContext<IEntitySelectionContext | null>(null);

export const useEntitySelectionContext = () => {
  const ctx = useContext(EntitySelectionContext);
  assertNotNil(ctx);
  return ctx;
};

export const PanelStateContext = createContext<IPanelStateContext | null>(null);

export const usePanelStateContext = () => {
  const ctx = useContext(PanelStateContext);
  assertNotNil(ctx);
  return ctx;
};
